let data = {
    name: 'Root',
    children: [
      {
        name: 'Utilities',
        children: [
          {
            name: 'Water Utilities',
            children: [
              {
                name: 'AWK',
                description: 'American Water Works Company, Inc.',
                size: 252,
                color: -4.91,
              },
            ],
            color: 2.23,
          },
          {
            name: 'Gas Utilities',
            children: [
              {
                name: 'CNP',
                description: 'CenterPoint Energy, Inc.',
                size: 280,
                color: 3.74,
              },
              {
                name: 'OKE',
                description: 'ONEOK, Inc.',
                size: 644,
                color: 4.9,
              },
            ],
            color: -4.67,
          },
          {
            name: 'Diversified Utilities',
            children: [
              {
                name: 'NI',
                description: 'NiSource Inc.',
                size: 171,
                color: -1.36,
              },
              {
                name: 'NRG',
                description: 'NRG Energy, Inc.',
                size: 209,
                color: -1.51,
              },
              {
                name: 'ES',
                description: 'Eversource Energy',
                size: 400,
                color: -4.9,
              },
              {
                name: 'PEG',
                description: 'Public Service Enterprise Group Incorporated',
                size: 540,
                color: -3.27,
              },
              {
                name: 'SRE',
                description: 'Sempra Energy',
                size: 630,
                color: -3.71,
              },
              {
                name: 'EXC',
                description: 'Exelon Corporation',
                size: 858,
                color: 3.82,
              },
            ],
            color: -2.85,
          },
          {
            name: 'Electric Utilities',
            children: [
              {
                name: 'SCG',
                description: 'SCANA Corporation',
                size: 110,
                color: 1.56,
              },
              {
                name: 'PNW',
                description: 'Pinnacle West Capital Corporation',
                size: 231,
                color: 3.08,
              },
              {
                name: 'AES',
                description: 'The AES Corporation',
                size: 231,
                color: 3.26,
              },
              {
                name: 'LNT',
                description: 'Alliant Energy Corporation',
                size: 242,
                color: -1.92,
              },
              {
                name: 'CMS',
                description: 'CMS Energy Corporation',
                size: 360,
                color: 3.61,
              },
              {
                name: 'AEE',
                description: 'Ameren Corporation',
                size: 380,
                color: 4.6,
              },
              {
                name: 'ETR',
                description: 'Entergy Corporation',
                size: 400,
                color: 3.48,
              },
              {
                name: 'FE',
                description: 'FirstEnergy Corp.',
                size: 440,
                color: 3.66,
              },
              {
                name: 'DTE',
                description: 'DTE Energy Company',
                size: 486,
                color: 3.7,
              },
              {
                name: 'PPL',
                description: 'PPL Corporation',
                size: 513,
                color: -2,
              },
              {
                name: 'WEC',
                description: 'WEC Energy Group, Inc.',
                size: 540,
                color: 1.65,
              },
              {
                name: 'EIX',
                description: 'Edison International',
                size: 575,
                color: 4.01,
              },
              {
                name: 'PCG',
                description: 'PG&E Corporation',
                size: 550,
                color: -1.68,
              },
              {
                name: 'XEL',
                description: 'Xcel Energy Inc.',
                size: 600,
                color: 1.72,
              },
              {
                name: 'ED',
                description: 'Consolidated Edison, Inc.',
                size: 660,
                color: -3.9,
              },
              {
                name: 'AEP',
                description: 'American Electric Power Company, Inc.',
                size: 891,
                color: 3.64,
              },
              {
                name: 'D',
                description: 'Dominion Energy, Inc.',
                size: 1155,
                color: -1.52,
              },
              {
                name: 'SO',
                description: 'The Southern Company',
                size: 1196,
                color: 2.18,
              },
              {
                name: 'DUK',
                description: 'Duke Energy Corporation',
                size: 1472,
                color: -4.18,
              },
              {
                name: 'NEE',
                description: 'NextEra Energy, Inc.',
                size: 2024,
                color: 4.51,
              },
            ],
            color: 3.83,
          },
        ],
        color: 1.82,
      },
      {
        name: 'Industrial Goods',
        children: [
          {
            name: 'General Contractors',
            children: [
              {
                name: 'PWR',
                description: 'Quanta Services, Inc.',
                size: 176,
                color: -1.99,
              },
            ],
            color: 0.45,
          },
          {
            name: 'Heavy Construction',
            children: [
              {
                name: 'FLR',
                description: 'Fluor Corporation',
                size: 112,
                color: -0.13,
              },
            ],
            color: -4.35,
          },
          {
            name: 'Small Tools & Accessories',
            children: [
              {
                name: 'SNA',
                description: 'Snap-on Incorporated',
                size: 160,
                color: 0.75,
              },
            ],
            color: -0.59,
          },
          {
            name: 'Machine Tools & Accessories',
            children: [
              {
                name: 'SWK',
                description: 'Stanley Black & Decker, Inc.',
                size: 442,
                color: 2.29,
              },
            ],
            color: -4.27,
          },
          {
            name: 'Lumber, Wood Production',
            children: [
              {
                name: 'WY',
                description: 'Weyerhaeuser Company',
                size: 558,
                color: 2.33,
              },
            ],
            color: 2.45,
          },
          {
            name: 'Industrial Equipment & Components',
            children: [
              {
                name: 'PNR',
                description: 'Pentair plc',
                size: 168,
                color: -4.85,
              },
              {
                name: 'PH',
                description: 'Parker-Hannifin Corporation',
                size: 483,
                color: -1.19,
              },
            ],
            color: 2.63,
          },
          {
            name: 'General Building Materials',
            children: [
              {
                name: 'MAS',
                description: 'Masco Corporation',
                size: 290,
                color: -0.67,
              },
              {
                name: 'MLM',
                description: 'Martin Marietta Materials, Inc.',
                size: 350,
                color: -1.75,
              },
              {
                name: 'VMC',
                description: 'Vulcan Materials Company',
                size: 375,
                color: 4.35,
              },
            ],
            color: -4.61,
          },
          {
            name: 'Residential Construction',
            children: [
              {
                name: 'PHM',
                description: 'PulteGroup, Inc.',
                size: 196,
                color: -0.07,
              },
              {
                name: 'LEN',
                description: 'Lennar Corporation',
                size: 392,
                color: -3.71,
              },
              {
                name: 'DHI',
                description: 'D.R. Horton, Inc.',
                size: 392,
                color: -0.08,
              },
            ],
            color: -2.84,
          },
          {
            name: 'Industrial Electrical Equipment',
            children: [
              {
                name: 'AOS',
                description: 'A. O. Smith Corporation',
                size: 238,
                color: -3.02,
              },
              {
                name: 'EMR',
                description: 'Emerson Electric Co.',
                size: 1054,
                color: -2.67,
              },
            ],
            color: -0.23,
          },
          {
            name: 'Waste Management',
            children: [
              {
                name: 'SRCL',
                description: 'Stericycle, Inc.',
                size: 160,
                color: 0.98,
              },
              {
                name: 'RSG',
                description: 'Republic Services, Inc.',
                size: 600,
                color: 1.57,
              },
              {
                name: 'WM',
                description: 'Waste Management, Inc.',
                size: 950,
                color: 3.7,
              },
            ],
            color: 1.29,
          },
          {
            name: 'Aerospace/Defense - Major Diversified',
            children: [
              {
                name: 'TXT',
                description: 'Textron Inc.',
                size: 288,
                color: -3.45,
              },
              {
                name: 'NOC',
                description: 'Northrop Grumman Corporation',
                size: 846,
                color: -2.24,
              },
            ],
            color: 1.94,
          },
          {
            name: 'Farm & Construction Machinery',
            children: [
              {
                name: 'DE',
                description: 'Deere & Company',
                size: 1035,
                color: 0.38,
              },
              {
                name: 'CAT',
                description: 'Caterpillar Inc.',
                size: 1800,
                color: -4.97,
              },
            ],
            color: 3.33,
          },
          {
            name: 'Aerospace/Defense Products & Services',
            children: [
              {
                name: 'HII',
                description: 'Huntington Ingalls Industries, Inc.',
                size: 294,
                color: -4.16,
              },
              {
                name: 'LLL',
                description: 'L3 Technologies, Inc.',
                size: 420,
                color: -2.6,
              },
              {
                name: 'TDG',
                description: 'Transdigm Group Incorporated Tr',
                size: 496,
                color: 3.93,
              },
              {
                name: 'COL',
                description: 'Rockwell Collins, Inc.',
                size: 558,
                color: 1.84,
              },
              {
                name: 'RTN',
                description: 'Raytheon Company',
                size: 1456,
                color: 4.8,
              },
              {
                name: 'GD',
                description: 'General Dynamics Corporation',
                size: 1508,
                color: 4.93,
              },
              {
                name: 'LMT',
                description: 'Lockheed Martin Corporation',
                size: 2310,
                color: -4.17,
              },
              {
                name: 'UTX',
                description: 'United Technologies Corporation',
                size: 2695,
                color: -4.81,
              },
              {
                name: 'BA',
                description: 'The Boeing Company',
                size: 5187,
                color: 0.18,
              },
            ],
            color: 3.25,
          },
          {
            name: 'Diversified Machinery',
            children: [
              {
                name: 'FLS',
                description: 'Flowserve Corporation',
                size: 192,
                color: 1.27,
              },
              {
                name: 'DOV',
                description: 'Dover Corporation',
                size: 336,
                color: -2.39,
              },
              {
                name: 'XYL',
                description: 'Xylem Inc.',
                size: 350,
                color: 4.52,
              },
              {
                name: 'AME',
                description: 'AMETEK, Inc.',
                size: 475,
                color: -2.78,
              },
              {
                name: 'CMI',
                description: 'Cummins Inc.',
                size: 600,
                color: 0.84,
              },
              {
                name: 'ROK',
                description: 'Rockwell Automation Inc.',
                size: 630,
                color: -2.42,
              },
              {
                name: 'IR',
                description: 'Ingersoll-Rand Plc',
                size: 621,
                color: -2.92,
              },
              {
                name: 'ROP',
                description: 'Roper Technologies, Inc.',
                size: 828,
                color: -1.47,
              },
              {
                name: 'ETN',
                description: 'Eaton Corporation plc',
                size: 980,
                color: -1.11,
              },
              {
                name: 'ITW',
                description: 'Illinois Tool Works Inc.',
                size: 1260,
                color: 2.11,
              },
              {
                name: 'DHR',
                description: 'Danaher Corporation',
                size: 1938,
                color: 1.72,
              },
              {
                name: 'GE',
                description: 'General Electric Company',
                size: 3060,
                color: 3.62,
              },
              {
                name: 'HON',
                description: 'Honeywell International Inc.',
                size: 3120,
                color: 2.7,
              },
              {
                name: 'MMM',
                description: '3M Company',
                size: 3250,
                color: -1.51,
              },
            ],
            color: -1.48,
          },
        ],
        color: -4.71,
      },
      {
        name: 'Healthcare',
        children: [
          {
            name: 'Drug Related Products',
            children: [
              {
                name: 'PRGO',
                description: 'Perrigo Company plc',
                size: 72,
                color: 0,
              },
            ],
            color: 1.08,
          },
          {
            name: 'Specialized Health Services',
            children: [
              {
                name: 'DVA',
                description: 'DaVita Inc.',
                size: 234,
                color: 2.14,
              },
            ],
            color: 4.59,
          },
          {
            name: 'Diagnostic Substances',
            children: [
              {
                name: 'IDXX',
                description: 'IDEXX Laboratories, Inc.',
                size: 484,
                color: -1.5,
              },
            ],
            color: -1.18,
          },
          {
            name: 'Hospitals',
            children: [
              {
                name: 'UHS',
                description: 'Universal Health Services, Inc.',
                size: 207,
                color: 2.67,
              },
              {
                name: 'HCA',
                description: 'HCA Healthcare, Inc.',
                size: 759,
                color: 2.08,
              },
            ],
            color: -1.96,
          },
          {
            name: 'Drugs - Generic',
            children: [
              {
                name: 'MYL',
                description: 'Mylan N.V.',
                size: 420,
                color: -0.07,
              },
              {
                name: 'ZTS',
                description: 'Zoetis Inc.',
                size: 980,
                color: -4.12,
              },
              {
                name: 'AGN',
                description: 'Allergan plc',
                size: 1450,
                color: 2.4,
              },
            ],
            color: -0.8,
          },
          {
            name: 'Medical Laboratories & Research',
            children: [
              {
                name: 'PKI',
                description: 'PerkinElmer, Inc.',
                size: 176,
                color: -4.3,
              },
              {
                name: 'DGX',
                description: 'Quest Diagnostics Incorporated',
                size: 330,
                color: 1.75,
              },
              {
                name: 'LH',
                description: 'Laboratory Corporation of America Holdings',
                size: 414,
                color: 1.08,
              },
              {
                name: 'A',
                description: 'Agilent Technologies, Inc.',
                size: 468,
                color: 1.42,
              },
              {
                name: 'IQV',
                description: 'IQVIA Holdings Inc.',
                size: 572,
                color: -4.79,
              },
              {
                name: 'TMO',
                description: 'Thermo Fisher Scientific Inc.',
                size: 2080,
                color: -0.96,
              },
            ],
            color: 3.04,
          },
          {
            name: 'Medical Instruments & Supplies',
            children: [
              {
                name: 'XRAY',
                description: 'DENTSPLY SIRONA Inc.',
                size: 345,
                color: 2.44,
              },
              {
                name: 'VAR',
                description: 'Varian Medical Systems, Inc.',
                size: 276,
                color: 0.93,
              },
              {
                name: 'HOLX',
                description: 'Hologic, Inc.',
                size: 299,
                color: -3.49,
              },
              {
                name: 'COO',
                description: 'The Cooper Companies, Inc.',
                size: 324,
                color: -0.77,
              },
              {
                name: 'WAT',
                description: 'Waters Corporation',
                size: 396,
                color: 4,
              },
              {
                name: 'MTD',
                description: 'Mettler-Toledo International Inc.',
                size: 400,
                color: -0.33,
              },
              {
                name: 'RMD',
                description: 'ResMed Inc.',
                size: 400,
                color: -3.15,
              },
              {
                name: 'BAX',
                description: 'Baxter International Inc.',
                size: 1092,
                color: -0.52,
              },
              {
                name: 'ILMN',
                description: 'Illumina, Inc.',
                size: 1287,
                color: 0.58,
              },
              {
                name: 'ISRG',
                description: 'Intuitive Surgical, Inc.',
                size: 1554,
                color: 1.84,
              },
              {
                name: 'BDX',
                description: 'Becton, Dickinson and Company',
                size: 1764,
                color: 0,
              },
            ],
            color: 2.23,
          },
          {
            name: 'Medical Appliances & Equipment',
            children: [
              {
                name: 'ABMD',
                description: 'ABIOMED, Inc.',
                size: 492,
                color: 4.41,
              },
              {
                name: 'ZBH',
                description: 'Zimmer Biomet Holdings, Inc.',
                size: 703,
                color: -2.5,
              },
              {
                name: 'ALGN',
                description: 'Align Technology, Inc.',
                size: 814,
                color: -2.42,
              },
              {
                name: 'EW',
                description: 'Edwards Lifesciences Corporation',
                size: 861,
                color: -1.49,
              },
              {
                name: 'BSX',
                description: 'Boston Scientific Corporation',
                size: 1302,
                color: 2.54,
              },
              {
                name: 'SYK',
                description: 'Stryker Corporation',
                size: 1638,
                color: 3.67,
              },
              {
                name: 'ABT',
                description: 'Abbott Laboratories',
                size: 3040,
                color: -3.98,
              },
              {
                name: 'MDT',
                description: 'Medtronic plc',
                size: 3268,
                color: 4.86,
              },
            ],
            color: -4.57,
          },
          {
            name: 'Biotechnology',
            children: [
              {
                name: 'NKTR',
                description: 'Nektar Therapeutics',
                size: 221,
                color: -1.93,
              },
              {
                name: 'INCY',
                description: 'Incyte Corporation',
                size: 390,
                color: 2.51,
              },
              {
                name: 'ALXN',
                description: 'Alexion Pharmaceuticals, Inc.',
                size: 861,
                color: 0.48,
              },
              {
                name: 'REGN',
                description: 'Regeneron Pharmaceuticals, Inc.',
                size: 1066,
                color: -3,
              },
              {
                name: 'VRTX',
                description: 'Vertex Pharmaceuticals Incorporated',
                size: 1269,
                color: -4.27,
              },
              {
                name: 'CELG',
                description: 'Celgene Corporation',
                size: 1850,
                color: -0.52,
              },
              {
                name: 'BIIB',
                description: 'Biogen Inc.',
                size: 2200,
                color: 2.8,
              },
              {
                name: 'GILD',
                description: 'Gilead Sciences, Inc.',
                size: 2795,
                color: -3.1,
              },
              {
                name: 'AMGN',
                description: 'Amgen Inc.',
                size: 3510,
                color: 0.58,
              },
            ],
            color: -2.18,
          },
          {
            name: 'Health Care Plans',
            children: [
              {
                name: 'CNC',
                description: 'Centene Corporation',
                size: 560,
                color: -2.84,
              },
              {
                name: 'ESRX',
                description: 'Express Scripts Holding Company',
                size: 1080,
                color: -2.26,
              },
              {
                name: 'HUM',
                description: 'Humana Inc.',
                size: 1148,
                color: 3.81,
              },
              {
                name: 'CI',
                description: 'Cigna Corporation',
                size: 1160,
                color: 3.44,
              },
              {
                name: 'AET',
                description: 'Aetna Inc.',
                size: 1560,
                color: -1.8,
              },
              {
                name: 'ANTM',
                description: 'Anthem, Inc.',
                size: 1640,
                color: 0.43,
              },
              {
                name: 'CVS',
                description: 'CVS Health Corporation',
                size: 1681,
                color: -1.68,
              },
              {
                name: 'UNH',
                description: 'UnitedHealth Group Incorporated',
                size: 6237,
                color: -0.57,
              },
            ],
            color: 3.21,
          },
          {
            name: 'Drug Manufacturers - Major',
            children: [
              {
                name: 'BMY',
                description: 'Bristol-Myers Squibb Company',
                size: 2688,
                color: -4.06,
              },
              {
                name: 'LLY',
                description: 'Eli Lilly and Company',
                size: 2944,
                color: 4.87,
              },
              {
                name: 'ABBV',
                description: 'AbbVie Inc.',
                size: 4224,
                color: 0.13,
              },
              {
                name: 'MRK',
                description: 'Merck & Co., Inc.',
                size: 4928,
                color: 2.05,
              },
              {
                name: 'PFE',
                description: 'Pfizer Inc.',
                size: 6664,
                color: -0.76,
              },
              {
                name: 'JNJ',
                description: 'Johnson & Johnson',
                size: 9800,
                color: 1.68,
              },
            ],
            color: 4.39,
          },
        ],
        color: 3.56,
      },
      {
        name: 'Basic Materials',
        children: [
          {
            name: 'Aluminum',
            children: [
              {
                name: 'AA',
                description: 'Alcoa Corporation',
                size: 114,
                color: 3.43,
              },
            ],
            color: -4.23,
          },
          {
            name: 'Gold',
            children: [
              {
                name: 'NEM',
                description: 'Newmont Mining Corporation',
                size: 418,
                color: -0.12,
              },
            ],
            color: 4.87,
          },
          {
            name: 'Steel & Iron',
            children: [
              {
                name: 'NUE',
                description: 'Nucor Corporation',
                size: 420,
                color: -2.69,
              },
            ],
            color: -4.82,
          },
          {
            name: 'Agricultural Chemicals',
            children: [
              {
                name: 'CF',
                description: 'CF Industries Holdings, Inc.',
                size: 196,
                color: -0.46,
              },
              {
                name: 'MOS',
                description: 'The Mosaic Company',
                size: 224,
                color: -1.05,
              },
            ],
            color: 1.51,
          },
          {
            name: 'Copper',
            children: [
              {
                name: 'FCX',
                description: 'Freeport-McMoRan Inc.',
                size: 504,
                color: 4.06,
              },
            ],
            color: -3.71,
          },
          {
            name: 'Oil & Gas Drilling & Exploration',
            children: [
              {
                name: 'DO',
                description: 'Diamond Offshore Drilling, Inc.',
                size: 48,
                color: 0.61,
              },
              {
                name: 'HP',
                description: 'Helmerich & Payne, Inc.',
                size: 144,
                color: 0.15,
              },
              {
                name: 'CXO',
                description: 'Concho Resources Inc.',
                size: 480,
                color: 3.21,
              },
            ],
            color: 4.12,
          },
          {
            name: 'Oil & Gas Pipelines',
            children: [
              {
                name: 'WMB',
                description: 'The Williams Companies, Inc.',
                size: 440,
                color: 2.14,
              },
              {
                name: 'KMI',
                description: 'Kinder Morgan, Inc.',
                size: 682,
                color: -1.48,
              },
            ],
            color: -4.27,
          },
          {
            name: 'Oil & Gas Refining & Marketing',
            children: [
              {
                name: 'HFC',
                description: 'HollyFrontier Corporation',
                size: 276,
                color: -4.45,
              },
              {
                name: 'ANDV',
                description: 'Andeavor',
                size: 552,
                color: 0.46,
              },
              {
                name: 'MPC',
                description: 'Marathon Petroleum Corporation',
                size: 936,
                color: -2.27,
              },
              {
                name: 'VLO',
                description: 'Valero Energy Corporation',
                size: 1225,
                color: 3.88,
              },
              {
                name: 'PSX',
                description: 'Phillips 66',
                size: 1372,
                color: 1,
              },
            ],
            color: 4.38,
          },
          {
            name: 'Oil & Gas Equipment & Services',
            children: [
              {
                name: 'FTI',
                description: 'TechnipFMC plc',
                size: 340,
                color: -1.16,
              },
              {
                name: 'NOV',
                description: 'National Oilwell Varco, Inc.',
                size: 357,
                color: 2.44,
              },
              {
                name: 'BHGE',
                description: 'Baker Hughes, a GE company',
                size: 760,
                color: 2.65,
              },
              {
                name: 'HAL',
                description: 'Halliburton Company',
                size: 798,
                color: -2.87,
              },
              {
                name: 'SLB',
                description: 'Schlumberger Limited',
                size: 1927,
                color: 3.14,
              },
            ],
            color: -1.38,
          },
          {
            name: 'Chemicals - Major Diversified',
            children: [
              {
                name: 'FMC',
                description: 'FMC Corporation',
                size: 242,
                color: -3.93,
              },
              {
                name: 'EMN',
                description: 'Eastman Chemical Company',
                size: 352,
                color: -2.48,
              },
              {
                name: 'APD',
                description: 'Air Products and Chemicals, Inc.',
                size: 836,
                color: 1.68,
              },
              {
                name: 'DWDP',
                description: 'DowDuPont Inc.',
                size: 3705,
                color: 1.83,
              },
            ],
            color: -0.94,
          },
          {
            name: 'Specialty Chemicals',
            children: [
              {
                name: 'ALB',
                description: 'Albemarle Corporation',
                size: 190,
                color: -0.94,
              },
              {
                name: 'IFF',
                description: 'International Flavors & Fragrances Inc.',
                size: 247,
                color: 2.25,
              },
              {
                name: 'PPG',
                description: 'PPG Industries, Inc.',
                size: 621,
                color: -3,
              },
              {
                name: 'SHW',
                description: 'The Sherwin-Williams Company',
                size: 966,
                color: 2.46,
              },
              {
                name: 'ECL',
                description: 'Ecolab Inc.',
                size: 966,
                color: -0.15,
              },
              {
                name: 'LYB',
                description: 'LyondellBasell Industries N.V.',
                size: 1023,
                color: -1.91,
              },
              {
                name: 'PX',
                description: 'Praxair, Inc.',
                size: 1122,
                color: -1.28,
              },
            ],
            color: 2.91,
          },
          {
            name: 'Independent Oil & Gas',
            children: [
              {
                name: 'SWN',
                description: 'Southwestern Energy Company',
                size: 70,
                color: -1.55,
              },
              {
                name: 'NFX',
                description: 'Newfield Exploration Company',
                size: 154,
                color: -0.75,
              },
              {
                name: 'XEC',
                description: 'Cimarex Energy Co.',
                size: 240,
                color: -3.92,
              },
              {
                name: 'COG',
                description: 'Cabot Oil & Gas Corporation',
                size: 299,
                color: 1.15,
              },
              {
                name: 'EQT',
                description: 'EQT Corporation',
                size: 368,
                color: 1.05,
              },
              {
                name: 'NBL',
                description: 'Noble Energy, Inc.',
                size: 460,
                color: 2.55,
              },
              {
                name: 'APA',
                description: 'Apache Corporation',
                size: 437,
                color: 1.85,
              },
              {
                name: 'MRO',
                description: 'Marathon Oil Corporation',
                size: 475,
                color: 2.13,
              },
              {
                name: 'HES',
                description: 'Hess Corporation',
                size: 513,
                color: -1.87,
              },
              {
                name: 'DVN',
                description: 'Devon Energy Corporation',
                size: 625,
                color: 2.57,
              },
              {
                name: 'PXD',
                description: 'Pioneer Natural Resources Company',
                size: 825,
                color: -2.38,
              },
              {
                name: 'APC',
                description: 'Anadarko Petroleum Corporation',
                size: 891,
                color: 0.03,
              },
              {
                name: 'OXY',
                description: 'Occidental Petroleum Corporation',
                size: 1650,
                color: -3.46,
              },
              {
                name: 'EOG',
                description: 'EOG Resources, Inc.',
                size: 1820,
                color: -0.55,
              },
              {
                name: 'COP',
                description: 'ConocoPhillips',
                size: 2184,
                color: -2.11,
              },
            ],
            color: -0.57,
          },
          {
            name: 'Major Integrated Oil & Gas',
            children: [
              {
                name: 'CVX',
                description: 'Chevron Corporation',
                size: 6148,
                color: 4.4,
              },
              {
                name: 'XOM',
                description: 'Exxon Mobil Corporation',
                size: 9010,
                color: 3.03,
              },
            ],
            color: 3.87,
          },
        ],
        color: -1.47,
      },
      {
        name: 'Consumer Goods',
        children: [
          {
            name: 'Rubber & Plastics',
            children: [
              {
                name: 'GT',
                description: 'The Goodyear Tire & Rubber Company',
                size: 48,
                color: -1.85,
              },
            ],
            color: -3.67,
          },
          {
            name: 'Recreational Vehicles',
            children: [
              {
                name: 'HOG',
                description: 'Harley-Davidson, Inc.',
                size: 112,
                color: -4.24,
              },
            ],
            color: 3.39,
          },
          {
            name: 'Appliances',
            children: [
              {
                name: 'WHR',
                description: 'Whirlpool Corporation',
                size: 165,
                color: -3.28,
              },
            ],
            color: 4.11,
          },
          {
            name: 'Business Equipment',
            children: [
              {
                name: 'AVY',
                description: 'Avery Dennison Corporation',
                size: 216,
                color: -1.97,
              },
            ],
            color: -1.94,
          },
          {
            name: 'Cleaning Products',
            children: [
              {
                name: 'CHD',
                description: 'Church & Dwight Co., Inc.',
                size: 270,
                color: -1.82,
              },
            ],
            color: 3.97,
          },
          {
            name: 'Beverages - Brewers',
            children: [
              {
                name: 'TAP',
                description: 'Molson Coors Brewing Company',
                size: 294,
                color: 0.83,
              },
            ],
            color: 4.68,
          },
          {
            name: 'Toys & Games',
            children: [
              {
                name: 'MAT',
                description: 'Mattel, Inc.',
                size: 114,
                color: 4.01,
              },
              {
                name: 'HAS',
                description: 'Hasbro, Inc.',
                size: 285,
                color: -2.91,
              },
            ],
            color: -4.97,
          },
          {
            name: 'Trucks & Other Vehicles',
            children: [
              {
                name: 'PCAR',
                description: 'PACCAR Inc',
                size: 484,
                color: 3.27,
              },
            ],
            color: -2.49,
          },
          {
            name: 'Farm Products',
            children: [
              {
                name: 'ADM',
                description: 'Archer-Daniels-Midland Company',
                size: 616,
                color: 2.23,
              },
            ],
            color: 5,
          },
          {
            name: 'Housewares & Accessories',
            children: [
              {
                name: 'NWL',
                description: 'Newell Brands Inc.',
                size: 312,
                color: 1.7,
              },
              {
                name: 'CLX',
                description: 'The Clorox Company',
                size: 408,
                color: 1.19,
              },
            ],
            color: 3.17,
          },
          {
            name: 'Home Furnishings & Fixtures',
            children: [
              {
                name: 'LEG',
                description: 'Leggett & Platt, Incorporated',
                size: 130,
                color: -3.96,
              },
              {
                name: 'FBHS',
                description: 'Fortune Brands Home & Security, Inc.',
                size: 182,
                color: -1.47,
              },
              {
                name: 'MHK',
                description: 'Mohawk Industries, Inc.',
                size: 408,
                color: 1.18,
              },
            ],
            color: -1.59,
          },
          {
            name: 'Meat Products',
            children: [
              {
                name: 'HRL',
                description: 'Hormel Foods Corporation',
                size: 270,
                color: 0.14,
              },
              {
                name: 'TSN',
                description: 'Tyson Foods, Inc.',
                size: 315,
                color: 3.09,
              },
            ],
            color: -3.27,
          },
          {
            name: 'Auto Parts',
            children: [
              {
                name: 'DLPH',
                description: 'Delphi Technologies PLC',
                size: 96,
                color: -4.08,
              },
              {
                name: 'BWA',
                description: 'BorgWarner Inc.',
                size: 176,
                color: -2.17,
              },
              {
                name: 'LKQ',
                description: 'LKQ Corporation',
                size: 192,
                color: -2.68,
              },
              {
                name: 'JCI',
                description: 'Johnson Controls International plc',
                size: 667,
                color: -4.55,
              },
            ],
            color: 0.06,
          },
          {
            name: 'Beverages - Wineries & Distillers',
            children: [
              {
                name: 'BF-B',
                description: 'Brown-Forman Corporation',
                size: 666,
                color: -2.39,
              },
              {
                name: 'STZ',
                description: 'Constellation Brands, Inc.',
                size: 1073,
                color: -2.9,
              },
            ],
            color: 2.83,
          },
          {
            name: 'Food - Major Diversified',
            children: [
              {
                name: 'KHC',
                description: 'The Kraft Heinz Company',
                size: 1521,
                color: 0.41,
              },
            ],
            color: 1.95,
          },
          {
            name: 'Packaging & Containers',
            children: [
              {
                name: 'OI',
                description: 'Owens-Illinois, Inc.',
                size: 72,
                color: -2.73,
              },
              {
                name: 'SEE',
                description: 'Sealed Air Corporation',
                size: 156,
                color: 2.41,
              },
              {
                name: 'PKG',
                description: 'Packaging Corporation of America',
                size: 228,
                color: -1.73,
              },
              {
                name: 'BLL',
                description: 'Ball Corporation',
                size: 285,
                color: -2.33,
              },
              {
                name: 'WRK',
                description: 'WestRock Company',
                size: 320,
                color: 3.38,
              },
              {
                name: 'IP',
                description: 'International Paper Company',
                size: 460,
                color: 2.33,
              },
            ],
            color: -0.29,
          },
          {
            name: 'Confectioners',
            children: [
              {
                name: 'HSY',
                description: 'The Hershey Company',
                size: 392,
                color: 2.11,
              },
              {
                name: 'MDLZ',
                description: 'Mondelez International, Inc.',
                size: 1232,
                color: 0.4,
              },
            ],
            color: -2.78,
          },
          {
            name: 'Textile - Apparel Clothing',
            children: [
              {
                name: 'HBI',
                description: 'Hanesbrands Inc.',
                size: 112,
                color: 0.52,
              },
              {
                name: 'UAA',
                description: 'Under Armour, Inc.',
                size: 160,
                color: -4.4,
              },
              {
                name: 'KORS',
                description: 'Michael Kors Holdings Limited',
                size: 204,
                color: 0.19,
              },
              {
                name: 'RL',
                description: 'Ralph Lauren Corporation',
                size: 208,
                color: -1.35,
              },
              {
                name: 'PVH',
                description: 'PVH Corp.',
                size: 240,
                color: 2.77,
              },
              {
                name: 'VFC',
                description: 'V.F. Corporation',
                size: 728,
                color: 2.91,
              },
            ],
            color: 0.05,
          },
          {
            name: 'Auto Manufacturers - Major',
            children: [
              {
                name: 'F',
                description: 'Ford Motor Company',
                size: 864,
                color: -2.07,
              },
              {
                name: 'GM',
                description: 'General Motors Company',
                size: 1088,
                color: -1.44,
              },
            ],
            color: 4.83,
          },
          {
            name: 'Processed & Packaged Goods',
            children: [
              {
                name: 'CPB',
                description: 'Campbell Soup Company',
                size: 256,
                color: 4.93,
              },
              {
                name: 'SJM',
                description: 'The J. M. Smucker Company',
                size: 256,
                color: -4.01,
              },
              {
                name: 'CAG',
                description: 'Conagra Brands, Inc.',
                size: 320,
                color: 1.46,
              },
              {
                name: 'MKC',
                description: 'McCormick & Company, Incorporated',
                size: 320,
                color: 1.07,
              },
              {
                name: 'K',
                description: 'Kellogg Company',
                size: 493,
                color: -1.06,
              },
              {
                name: 'GIS',
                description: 'General Mills, Inc.',
                size: 551,
                color: 3.56,
              },
            ],
            color: -0.71,
          },
          {
            name: 'Textile - Apparel Footwear & Accessories',
            children: [
              {
                name: 'FOSL',
                description: 'Fossil Group, Inc.',
                size: 54,
                color: -1.12,
              },
              {
                name: 'FL',
                description: 'Foot Locker, Inc.',
                size: 135,
                color: 2.86,
              },
              {
                name: 'TPR',
                description: 'Tapestry, Inc.',
                size: 315,
                color: 4.77,
              },
              {
                name: 'NKE',
                description: 'NIKE, Inc.',
                size: 2912,
                color: 3.25,
              },
            ],
            color: -0.97,
          },
          {
            name: 'Cigarettes',
            children: [
              {
                name: 'MO',
                description: 'Altria Group, Inc.',
                size: 2774,
                color: 4.84,
              },
              {
                name: 'PM',
                description: 'Philip Morris International Inc.',
                size: 3285,
                color: 4.3,
              },
            ],
            color: -1.96,
          },
          {
            name: 'Personal Products',
            children: [
              {
                name: 'KMB',
                description: 'Kimberly-Clark Corporation',
                size: 990,
                color: -2.56,
              },
              {
                name: 'EL',
                description: 'The Estee Lauder Companies Inc.',
                size: 1305,
                color: 2.19,
              },
              {
                name: 'CL',
                description: 'Colgate-Palmolive Company',
                size: 1440,
                color: -1.51,
              },
              {
                name: 'PG',
                description: 'The Procter & Gamble Company',
                size: 5146,
                color: 3.43,
              },
            ],
            color: -2.74,
          },
          {
            name: 'Beverages - Soft Drinks',
            children: [
              {
                name: 'CCE',
                description: 'Coca-Cola European Partners plc',
                size: 483,
                color: 4.99,
              },
              {
                name: 'MNST',
                description: 'Monster Beverage Corporation',
                size: 819,
                color: 3.78,
              },
              {
                name: 'PEP',
                description: 'PepsiCo, Inc.',
                size: 3906,
                color: -0.23,
              },
              {
                name: 'KO',
                description: 'The Coca-Cola Company',
                size: 4774,
                color: 0.23,
              },
            ],
            color: 0.5,
          },
          {
            name: 'Electronic Equipment',
            children: [
              {
                name: 'AAPL',
                description: 'Apple Inc.',
                size: 27531,
                color: -1.18,
              },
            ],
            color: -3.14,
          },
        ],
        color: -0.2,
      },
      {
        name: 'Services',
        children: [
          {
            name: 'Personal Services',
            children: [
              {
                name: 'HRB',
                description: 'H&R Block, Inc.',
                size: 30,
                color: 2.35,
              },
            ],
            color: 1.61,
          },
          {
            name: 'Security & Protection Services',
            children: [
              {
                name: 'ALLE',
                description: 'Allegion plc',
                size: 140,
                color: -3.9,
              },
            ],
            color: -4.63,
          },
          {
            name: 'Broadcasting - TV',
            children: [
              {
                name: 'NWSA',
                description: 'News Corporation',
                size: 152,
                color: 0.95,
              },
            ],
            color: -0.33,
          },
          {
            name: 'Technical Services',
            children: [
              {
                name: 'JEC',
                description: 'Jacobs Engineering Group Inc.',
                size: 171,
                color: -3.85,
              },
            ],
            color: 2.88,
          },
          {
            name: 'Medical Equipment Wholesale',
            children: [
              {
                name: 'HSIC',
                description: 'Henry Schein, Inc.',
                size: 238,
                color: -2.64,
              },
            ],
            color: -2.29,
          },
          {
            name: 'Rental & Leasing Services',
            children: [
              {
                name: 'URI',
                description: 'United Rentals, Inc.',
                size: 255,
                color: 0.67,
              },
            ],
            color: 4.43,
          },
          {
            name: 'Trucking',
            children: [
              {
                name: 'JBHT',
                description: 'J.B. Hunt Transport Services, Inc.',
                size: 272,
                color: 2.99,
              },
            ],
            color: -2.41,
          },
          {
            name: 'Jewelry Stores',
            children: [
              {
                name: 'TIF',
                description: 'Tiffany & Co.',
                size: 391,
                color: 0.35,
              },
            ],
            color: 4.98,
          },
          {
            name: 'Electronics Stores',
            children: [
              {
                name: 'BBY',
                description: 'Best Buy Co., Inc.',
                size: 468,
                color: -3.68,
              },
            ],
            color: 2.47,
          },
          {
            name: 'Advertising Agencies',
            children: [
              {
                name: 'IPG',
                description: 'The Interpublic Group of Companies, Inc.',
                size: 189,
                color: 2.17,
              },
              {
                name: 'OMC',
                description: 'Omnicom Group Inc.',
                size: 357,
                color: 1.6,
              },
            ],
            color: 0.68,
          },
          {
            name: 'Grocery Stores',
            children: [
              {
                name: 'KR',
                description: 'The Kroger Co.',
                size: 540,
                color: -4.17,
              },
            ],
            color: -4.94,
          },
          {
            name: 'Auto Dealerships',
            children: [
              {
                name: 'KMX',
                description: 'CarMax, Inc.',
                size: 299,
                color: 4.14,
              },
              {
                name: 'CPRT',
                description: 'Copart, Inc.',
                size: 322,
                color: -4.37,
              },
            ],
            color: 4.52,
          },
          {
            name: 'Staffing & Outsourcing Services',
            children: [
              {
                name: 'RHI',
                description: 'Robert Half International Inc.',
                size: 216,
                color: -4.19,
              },
              {
                name: 'PAYX',
                description: 'Paychex, Inc.',
                size: 621,
                color: 2.07,
              },
            ],
            color: 0.95,
          },
          {
            name: 'Food Wholesale',
            children: [
              {
                name: 'SYY',
                description: 'Sysco Corporation',
                size: 836,
                color: -2.59,
              },
            ],
            color: 2.7,
          },
          {
            name: 'Industrial Equipment Wholesale',
            children: [
              {
                name: 'FAST',
                description: 'Fastenal Company',
                size: 374,
                color: 2.02,
              },
              {
                name: 'GWW',
                description: 'W.W. Grainger, Inc.',
                size: 462,
                color: -3.33,
              },
            ],
            color: -3.68,
          },
          {
            name: 'Regional Airlines',
            children: [
              {
                name: 'ALK',
                description: 'Alaska Air Group, Inc.',
                size: 120,
                color: -1.17,
              },
              {
                name: 'LUV',
                description: 'Southwest Airlines Co.',
                size: 510,
                color: 3.76,
              },
            ],
            color: -3.88,
          },
          {
            name: 'Auto Parts Stores',
            children: [
              {
                name: 'AAP',
                description: 'Advance Auto Parts, Inc.',
                size: 198,
                color: -2.72,
              },
              {
                name: 'AZO',
                description: 'AutoZone, Inc.',
                size: 352,
                color: -3.52,
              },
              {
                name: 'ORLY',
                description: "O'Reilly Automotive, Inc.",
                size: 500,
                color: -4,
              },
            ],
            color: -3.54,
          },
          {
            name: 'Drugs Wholesale',
            children: [
              {
                name: 'CAH',
                description: 'Cardinal Health, Inc.',
                size: 299,
                color: -4.68,
              },
              {
                name: 'ABC',
                description: 'AmerisourceBergen Corporation',
                size: 368,
                color: 1.03,
              },
              {
                name: 'MCK',
                description: 'McKesson Corporation',
                size: 551,
                color: 4.37,
              },
            ],
            color: 0.3,
          },
          {
            name: 'Drug Stores',
            children: [
              {
                name: 'WBA',
                description: 'Walgreens Boots Alliance, Inc.',
                size: 1710,
                color: -3.56,
              },
            ],
            color: -4.34,
          },
          {
            name: 'Apparel Stores',
            children: [
              {
                name: 'URBN',
                description: 'Urban Outfitters, Inc.',
                size: 120,
                color: -4.02,
              },
              {
                name: 'JWN',
                description: 'Nordstrom, Inc.',
                size: 190,
                color: -0.59,
              },
              {
                name: 'LB',
                description: 'L Brands, Inc.',
                size: 190,
                color: -0.81,
              },
              {
                name: 'GPS',
                description: 'The Gap, Inc.',
                size: 240,
                color: 3.42,
              },
              {
                name: 'ROST',
                description: 'Ross Stores, Inc.',
                size: 703,
                color: 0.64,
              },
            ],
            color: 2.13,
          },
          {
            name: 'Specialty Eateries',
            children: [
              {
                name: 'SBUX',
                description: 'Starbucks Corporation',
                size: 1517,
                color: -3.16,
              },
            ],
            color: -3.79,
          },
          {
            name: 'Specialty Retail, Other',
            children: [
              {
                name: 'TSCO',
                description: 'Tractor Supply Company',
                size: 198,
                color: 2.38,
              },
              {
                name: 'GPC',
                description: 'Genuine Parts Company',
                size: 308,
                color: -1.67,
              },
              {
                name: 'ULTA',
                description: 'Ulta Beauty, Inc.',
                size: 322,
                color: -1.29,
              },
              {
                name: 'EBAY',
                description: 'eBay Inc.',
                size: 720,
                color: 2.06,
              },
            ],
            color: -2.65,
          },
          {
            name: 'Major Airlines',
            children: [
              {
                name: 'AAL',
                description: 'American Airlines Group Inc.',
                size: 374,
                color: 2.88,
              },
              {
                name: 'UAL',
                description: 'United Continental Holdings, Inc.',
                size: 484,
                color: -4.04,
              },
              {
                name: 'DAL',
                description: 'Delta Air Lines, Inc.',
                size: 819,
                color: -1.2,
              },
            ],
            color: 2.16,
          },
          {
            name: 'Department Stores',
            children: [
              {
                name: 'M',
                description: "Macy's, Inc.",
                size: 252,
                color: 0.62,
              },
              {
                name: 'KSS',
                description: "Kohl's Corporation",
                size: 264,
                color: -1.84,
              },
              {
                name: 'TJX',
                description: 'The TJX Companies, Inc.',
                size: 1376,
                color: 3.17,
              },
            ],
            color: -3.72,
          },
          {
            name: 'Lodging',
            children: [
              {
                name: 'EXPE',
                description: 'Expedia Group, Inc.',
                size: 510,
                color: 2.63,
              },
              {
                name: 'HLT',
                description: 'Hilton Worldwide Holdings Inc.',
                size: 630,
                color: 3.02,
              },
              {
                name: 'MAR',
                description: 'Marriott International, Inc.',
                size: 1216,
                color: -4.93,
              },
            ],
            color: -3.92,
          },
          {
            name: 'Resorts & Casinos',
            children: [
              {
                name: 'NCLH',
                description: 'Norwegian Cruise Line Holdings Ltd.',
                size: 242,
                color: 0.11,
              },
              {
                name: 'MGM',
                description: 'MGM Resorts International',
                size: 374,
                color: 3.05,
              },
              {
                name: 'WYNN',
                description: 'Wynn Resorts, Limited',
                size: 418,
                color: -3.51,
              },
              {
                name: 'RCL',
                description: 'Royal Caribbean Cruises Ltd.',
                size: 544,
                color: 0.17,
              },
              {
                name: 'CCL',
                description: 'Carnival Corporation',
                size: 960,
                color: -3.06,
              },
            ],
            color: -2.77,
          },
          {
            name: 'Restaurants',
            children: [
              {
                name: 'CMG',
                description: 'Chipotle Mexican Grill, Inc.',
                size: 299,
                color: -2.24,
              },
              {
                name: 'DRI',
                description: 'Darden Restaurants, Inc.',
                size: 322,
                color: 2.16,
              },
              {
                name: 'YUM',
                description: 'YUM! Brands, Inc.',
                size: 621,
                color: 1.58,
              },
              {
                name: 'MCD',
                description: "McDonald's Corporation",
                size: 2970,
                color: 3.97,
              },
            ],
            color: 2.11,
          },
          {
            name: 'Air Delivery & Freight Services',
            children: [
              {
                name: 'CHRW',
                description: 'C.H. Robinson Worldwide, Inc.',
                size: 300,
                color: -1.39,
              },
              {
                name: 'EXPD',
                description: 'Expeditors International of Washington, Inc.',
                size: 315,
                color: -0.36,
              },
              {
                name: 'FDX',
                description: 'FedEx Corporation',
                size: 1517,
                color: -0.47,
              },
              {
                name: 'UPS',
                description: 'United Parcel Service, Inc.',
                size: 2496,
                color: 3.53,
              },
            ],
            color: -0.48,
          },
          {
            name: 'Railroads',
            children: [
              {
                name: 'KSU',
                description: 'Kansas City Southern',
                size: 288,
                color: 3.81,
              },
              {
                name: 'NSC',
                description: 'Norfolk Southern Corporation',
                size: 1184,
                color: -2.29,
              },
              {
                name: 'CSX',
                description: 'CSX Corporation',
                size: 1518,
                color: 4.36,
              },
              {
                name: 'UNP',
                description: 'Union Pacific Corporation',
                size: 2795,
                color: -4.31,
              },
            ],
            color: -2.67,
          },
          {
            name: 'CATV Systems',
            children: [
              {
                name: 'DISCA',
                description: 'Discovery, Inc.',
                size: 340,
                color: 1.96,
              },
              {
                name: 'DISH',
                description: 'DISH Network Corporation',
                size: 360,
                color: 4.94,
              },
              {
                name: 'CHTR',
                description: 'Charter Communications, Inc.',
                size: 1715,
                color: -1.1,
              },
              {
                name: 'NFLX',
                description: 'Netflix, Inc.',
                size: 3726,
                color: 0.3,
              },
            ],
            color: 4.12,
          },
          {
            name: 'Home Improvement Stores',
            children: [
              {
                name: 'LOW',
                description: "Lowe's Companies, Inc.",
                size: 2125,
                color: -1.17,
              },
              {
                name: 'HD',
                description: 'The Home Depot, Inc.',
                size: 6120,
                color: -3.93,
              },
            ],
            color: -3.66,
          },
          {
            name: 'Business Services',
            children: [
              {
                name: 'ADS',
                description: 'Alliance Data Systems Corporation',
                size: 360,
                color: 4.55,
              },
              {
                name: 'GPN',
                description: 'Global Payments Inc.',
                size: 480,
                color: -1.4,
              },
              {
                name: 'VRSK',
                description: 'Verisk Analytics, Inc.',
                size: 540,
                color: 2.43,
              },
              {
                name: 'FLT',
                description: 'FleetCor Technologies, Inc.',
                size: 510,
                color: 2.53,
              },
              {
                name: 'INFO',
                description: 'IHS Markit Ltd.',
                size: 546,
                color: 1.52,
              },
              {
                name: 'CTAS',
                description: 'Cintas Corporation',
                size: 588,
                color: 4.89,
              },
              {
                name: 'FISV',
                description: 'Fiserv, Inc.',
                size: 837,
                color: -1.57,
              },
              {
                name: 'MCO',
                description: "Moody's Corporation",
                size: 899,
                color: 2.56,
              },
              {
                name: 'SPGI',
                description: 'S&P Global Inc.',
                size: 1334,
                color: -3.99,
              },
              {
                name: 'BKNG',
                description: 'Booking Holdings Inc.',
                size: 2576,
                color: -1.82,
              },
            ],
            color: -1.8,
          },
          {
            name: 'Entertainment - Diversified',
            children: [
              {
                name: 'VIAB',
                description: 'Viacom, Inc.',
                size: 375,
                color: -0.84,
              },
              {
                name: 'CBS',
                description: 'CBS Corporation',
                size: 575,
                color: 2.7,
              },
              {
                name: 'FOXA',
                description: 'Twenty-First Century Fox, Inc.',
                size: 2242,
                color: -0.43,
              },
              {
                name: 'CMCSA',
                description: 'Comcast Corporation',
                size: 4368,
                color: 0.31,
              },
              {
                name: 'DIS',
                description: 'The Walt Disney Company',
                size: 4452,
                color: -3.96,
              },
            ],
            color: 4.62,
          },
          {
            name: 'Discount, Variety Stores',
            children: [
              {
                name: 'DLTR',
                description: 'Dollar Tree, Inc.',
                size: 640,
                color: -4.54,
              },
              {
                name: 'DG',
                description: 'Dollar General Corporation',
                size: 704,
                color: -1.13,
              },
              {
                name: 'TGT',
                description: 'Target Corporation',
                size: 1176,
                color: 1.49,
              },
              {
                name: 'COST',
                description: 'Costco Wholesale Corporation',
                size: 2580,
                color: 0.12,
              },
              {
                name: 'WMT',
                description: 'Walmart Inc.',
                size: 7055,
                color: 2.4,
              },
            ],
            color: 0.3,
          },
          {
            name: 'Catalog & Mail Order Houses',
            children: [
              {
                name: 'AMZN',
                description: 'Amazon.com, Inc.',
                size: 24596,
                color: 4.82,
              },
            ],
            color: -1.92,
          },
        ],
        color: -1.91,
      },
      {
        name: 'Financial',
        children: [
          {
            name: 'Savings & Loans',
            children: [
              {
                name: 'PBCT',
                description: "People's United Financial, Inc.",
                size: 162,
                color: 3.56,
              },
            ],
            color: 4.33,
          },
          {
            name: 'REIT - Hotel/Motel',
            children: [
              {
                name: 'HST',
                description: 'Host Hotels & Resorts, Inc.',
                size: 342,
                color: 0.83,
              },
            ],
            color: -3.2,
          },
          {
            name: 'Property Management',
            children: [
              {
                name: 'CBRE',
                description: 'CBRE Group, Inc.',
                size: 351,
                color: -4.04,
              },
            ],
            color: 4.45,
          },
          {
            name: 'Regional - Mid-Atlantic Banks',
            children: [
              {
                name: 'CFG',
                description: 'Citizens Financial Group, Inc.',
                size: 405,
                color: -2.01,
              },
            ],
            color: 2.72,
          },
          {
            name: 'Regional - Northeast Banks',
            children: [
              {
                name: 'MTB',
                description: 'M&T Bank Corporation',
                size: 594,
                color: 3.09,
              },
            ],
            color: 0.56,
          },
          {
            name: 'Regional - Pacific Banks',
            children: [
              {
                name: 'ZION',
                description: 'Zions Bancorporation',
                size: 240,
                color: -2.55,
              },
              {
                name: 'SIVB',
                description: 'SVB Financial Group',
                size: 384,
                color: -2.08,
              },
            ],
            color: -3.02,
          },
          {
            name: 'REIT - Office',
            children: [
              {
                name: 'BXP',
                description: 'Boston Properties, Inc.',
                size: 342,
                color: -4.74,
              },
              {
                name: 'DLR',
                description: 'Digital Realty Trust, Inc.',
                size: 396,
                color: 1.21,
              },
            ],
            color: 1.42,
          },
          {
            name: 'Accident & Health Insurance',
            children: [
              {
                name: 'AIZ',
                description: 'Assurant, Inc.',
                size: 126,
                color: 1.47,
              },
              {
                name: 'UNM',
                description: 'Unum Group',
                size: 154,
                color: 1.64,
              },
              {
                name: 'AFL',
                description: 'Aflac Incorporated',
                size: 640,
                color: 3.52,
              },
            ],
            color: 3.91,
          },
          {
            name: 'REIT - Healthcare Facilities',
            children: [
              {
                name: 'HCP',
                description: 'HCP, Inc.',
                size: 230,
                color: -4.72,
              },
              {
                name: 'VTR',
                description: 'Ventas, Inc.',
                size: 391,
                color: -4.93,
              },
              {
                name: 'WELL',
                description: 'Welltower Inc.',
                size: 437,
                color: 4.14,
              },
            ],
            color: 1.09,
          },
          {
            name: 'Regional - Southeast Banks',
            children: [
              {
                name: 'RF',
                description: 'Regions Financial Corporation',
                size: 544,
                color: 4.79,
              },
              {
                name: 'BBT',
                description: 'BB&T Corporation',
                size: 1024,
                color: -0.39,
              },
            ],
            color: 3.21,
          },
          {
            name: 'Diversified Investments',
            children: [
              {
                name: 'CBOE',
                description: 'Cboe Global Markets, Inc.',
                size: 304,
                color: 1.73,
              },
              {
                name: 'NDAQ',
                description: 'Nasdaq, Inc.',
                size: 399,
                color: 1.36,
              },
              {
                name: 'ICE',
                description: 'Intercontinental Exchange, Inc.',
                size: 1110,
                color: 2.07,
              },
            ],
            color: -3.72,
          },
          {
            name: 'REIT - Diversified',
            children: [
              {
                name: 'VNO',
                description: 'Vornado Realty Trust',
                size: 287,
                color: 4.14,
              },
              {
                name: 'AMT',
                description: 'American Tower Corporation (REIT)',
                size: 1435,
                color: 3.4,
              },
            ],
            color: 3.22,
          },
          {
            name: 'REIT - Residential',
            children: [
              {
                name: 'AIV',
                description: 'Apartment Investment and Management Company',
                size: 136,
                color: 1.06,
              },
              {
                name: 'UDR',
                description: 'UDR, Inc.',
                size: 221,
                color: -3.72,
              },
              {
                name: 'ESS',
                description: 'Essex Property Trust, Inc.',
                size: 336,
                color: 3.83,
              },
              {
                name: 'AVB',
                description: 'AvalonBay Communities, Inc.',
                size: 496,
                color: -0.29,
              },
              {
                name: 'EQR',
                description: 'Equity Residential',
                size: 527,
                color: -2.33,
              },
            ],
            color: 1.86,
          },
          {
            name: 'REIT - Industrial',
            children: [
              {
                name: 'DRE',
                description: 'Duke Realty Corporation',
                size: 210,
                color: -3.67,
              },
              {
                name: 'EXR',
                description: 'Extra Space Storage Inc.',
                size: 252,
                color: 4.35,
              },
              {
                name: 'PLD',
                description: 'Prologis, Inc.',
                size: 726,
                color: 4.81,
              },
              {
                name: 'PSA',
                description: 'Public Storage',
                size: 825,
                color: -3.37,
              },
            ],
            color: 1.95,
          },
          {
            name: 'Insurance Brokers',
            children: [
              {
                name: 'WLTW',
                description: 'Willis Towers Watson Public Limited Company',
                size: 416,
                color: -3.93,
              },
              {
                name: 'AON',
                description: 'Aon plc',
                size: 736,
                color: 4.95,
              },
              {
                name: 'MMC',
                description: 'Marsh & McLennan Companies, Inc.',
                size: 896,
                color: 0.09,
              },
            ],
            color: 2.51,
          },
          {
            name: 'Life Insurance',
            children: [
              {
                name: 'BHF',
                description: 'Brighthouse Financial, Inc.',
                size: 128,
                color: 1.54,
              },
              {
                name: 'TMK',
                description: 'Torchmark Corporation',
                size: 224,
                color: -3.84,
              },
              {
                name: 'LNC',
                description: 'Lincoln National Corporation',
                size: 330,
                color: -0.33,
              },
              {
                name: 'PFG',
                description: 'Principal Financial Group, Inc.',
                size: 374,
                color: -0.29,
              },
              {
                name: 'PRU',
                description: 'Prudential Financial, Inc.',
                size: 966,
                color: -4.31,
              },
              {
                name: 'MET',
                description: 'MetLife, Inc.',
                size: 1050,
                color: -1.43,
              },
            ],
            color: -4.96,
          },
          {
            name: 'REIT - Retail',
            children: [
              {
                name: 'KIM',
                description: 'Kimco Realty Corporation',
                size: 168,
                color: -4.6,
              },
              {
                name: 'MAC',
                description: 'Macerich Company',
                size: 200,
                color: -4.62,
              },
              {
                name: 'SLG',
                description: 'SL Green Realty Corp.',
                size: 220,
                color: 3.98,
              },
              {
                name: 'FRT',
                description: 'Federal Realty Investment Trust',
                size: 221,
                color: -0.74,
              },
              {
                name: 'REG',
                description: 'Regency Centers Corporation',
                size: 255,
                color: -3.98,
              },
              {
                name: 'O',
                description: 'Realty Income Corporation',
                size: 374,
                color: 3.24,
              },
              {
                name: 'GGP',
                description: 'GGP Inc.',
                size: 462,
                color: 1.9,
              },
              {
                name: 'SPG',
                description: 'Simon Property Group, Inc.',
                size: 1300,
                color: -4.64,
              },
            ],
            color: -4.68,
          },
          {
            name: 'Regional - Midwest Banks',
            children: [
              {
                name: 'HBAN',
                description: 'Huntington Bancshares Incorporated',
                size: 351,
                color: -2.01,
              },
              {
                name: 'FITB',
                description: 'Fifth Third Bancorp',
                size: 459,
                color: -4.13,
              },
              {
                name: 'KEY',
                description: 'KeyCorp',
                size: 510,
                color: -2.2,
              },
              {
                name: 'USB',
                description: 'U.S. Bancorp',
                size: 1980,
                color: 2.01,
              },
            ],
            color: 2.75,
          },
          {
            name: 'Asset Management',
            children: [
              {
                name: 'LM',
                description: 'Legg Mason, Inc.',
                size: 70,
                color: 0.96,
              },
              {
                name: 'JEF',
                description: 'Jefferies Financial Group Inc.',
                size: 200,
                color: 1.53,
              },
              {
                name: 'AMG',
                description: 'Affiliated Managers Group, Inc.',
                size: 216,
                color: -2.46,
              },
              {
                name: 'IVZ',
                description: 'Invesco Ltd.',
                size: 270,
                color: -0.04,
              },
              {
                name: 'BEN',
                description: 'Franklin Resources, Inc.',
                size: 459,
                color: -0.46,
              },
              {
                name: 'AMP',
                description: 'Ameriprise Financial, Inc.',
                size: 520,
                color: -3.53,
              },
              {
                name: 'NTRS',
                description: 'Northern Trust Corporation',
                size: 650,
                color: 3.22,
              },
              {
                name: 'TROW',
                description: 'T. Rowe Price Group, Inc.',
                size: 750,
                color: -4.96,
              },
              {
                name: 'STT',
                description: 'State Street Corporation',
                size: 840,
                color: -4.11,
              },
              {
                name: 'BK',
                description: 'The Bank of New York Mellon Corporation',
                size: 1426,
                color: 4.86,
              },
              {
                name: 'BLK',
                description: 'BlackRock, Inc.',
                size: 2024,
                color: -4.64,
              },
            ],
            color: 2.89,
          },
          {
            name: 'Investment Brokerage - National',
            children: [
              {
                name: 'ETFC',
                description: 'E*TRADE Financial Corporation',
                size: 440,
                color: 2.78,
              },
              {
                name: 'CME',
                description: 'CME Group Inc.',
                size: 1440,
                color: 3.37,
              },
              {
                name: 'SCHW',
                description: 'The Charles Schwab Corporation',
                size: 1786,
                color: 4.73,
              },
              {
                name: 'GS',
                description: 'The Goldman Sachs Group, Inc.',
                size: 2301,
                color: 3.92,
              },
              {
                name: 'MS',
                description: 'Morgan Stanley',
                size: 2301,
                color: 3.89,
              },
            ],
            color: -3.7,
          },
          {
            name: 'Property & Casualty Insurance',
            children: [
              {
                name: 'RE',
                description: 'Everest Re Group, Ltd.',
                size: 252,
                color: -0.81,
              },
              {
                name: 'CINF',
                description: 'Cincinnati Financial Corporation',
                size: 325,
                color: -1.42,
              },
              {
                name: 'XL',
                description: 'XL Group Ltd',
                size: 375,
                color: 3.91,
              },
              {
                name: 'L',
                description: 'Loews Corporation',
                size: 448,
                color: 4.76,
              },
              {
                name: 'HIG',
                description: 'The Hartford Financial Services Group, Inc.',
                size: 504,
                color: 2.67,
              },
              {
                name: 'ALL',
                description: 'The Allstate Corporation',
                size: 864,
                color: 2.13,
              },
              {
                name: 'TRV',
                description: 'The Travelers Companies, Inc.',
                size: 928,
                color: -0.53,
              },
              {
                name: 'PGR',
                description: 'The Progressive Corporation',
                size: 920,
                color: 1.34,
              },
              {
                name: 'AIG',
                description: 'American International Group, Inc.',
                size: 1320,
                color: 3.93,
              },
              {
                name: 'BRK-B',
                description: 'Berkshire Hathaway Inc.',
                size: 12932,
                color: -3.14,
              },
            ],
            color: 1.77,
          },
          {
            name: 'Credit Services',
            children: [
              {
                name: 'NAVI',
                description: 'Navient Corporation',
                size: 72,
                color: 1,
              },
              {
                name: 'WU',
                description: 'The Western Union Company',
                size: 252,
                color: -1.26,
              },
              {
                name: 'EFX',
                description: 'Equifax Inc.',
                size: 405,
                color: 1.39,
              },
              {
                name: 'TSS',
                description: 'Total System Services, Inc.',
                size: 459,
                color: -2.04,
              },
              {
                name: 'SYF',
                description: 'Synchrony Financial',
                size: 660,
                color: -0.56,
              },
              {
                name: 'DFS',
                description: 'Discover Financial Services',
                size: 660,
                color: 2.22,
              },
              {
                name: 'COF',
                description: 'Capital One Financial Corporation',
                size: 1276,
                color: -0.4,
              },
              {
                name: 'AXP',
                description: 'American Express Company',
                size: 2242,
                color: 4.27,
              },
              {
                name: 'PYPL',
                description: 'PayPal Holdings, Inc.',
                size: 2832,
                color: 2.35,
              },
              {
                name: 'MA',
                description: 'Mastercard Incorporated',
                size: 5871,
                color: 2.42,
              },
              {
                name: 'V',
                description: 'Visa Inc.',
                size: 8343,
                color: 0.46,
              },
            ],
            color: 0.98,
          },
          {
            name: 'Money Center Banks',
            children: [
              {
                name: 'CMA',
                description: 'Comerica Incorporated',
                size: 408,
                color: 0.12,
              },
              {
                name: 'STI',
                description: 'SunTrust Banks, Inc.',
                size: 918,
                color: -4.83,
              },
              {
                name: 'PNC',
                description: 'The PNC Financial Services Group, Inc.',
                size: 1872,
                color: -1.98,
              },
              {
                name: 'C',
                description: 'Citigroup Inc.',
                size: 5084,
                color: -4.99,
              },
              {
                name: 'WFC',
                description: 'Wells Fargo & Company',
                size: 7777,
                color: 4.45,
              },
              {
                name: 'BAC',
                description: 'Bank of America Corporation',
                size: 8733,
                color: 1.3,
              },
              {
                name: 'JPM',
                description: 'JPMorgan Chase & Co.',
                size: 10824,
                color: 1.85,
              },
            ],
            color: 2.77,
          },
        ],
        color: 3.93,
      },
      {
        name: 'Technology',
        children: [
          {
            name: 'Security Software & Services',
            children: [
              {
                name: 'SYMC',
                description: 'Symantec Corporation',
                size: 320,
                color: 4.51,
              },
            ],
            color: -0.99,
          },
          {
            name: 'Processing Systems & Products',
            children: [
              {
                name: 'MSCI',
                description: 'MSCI Inc.',
                size: 297,
                color: -0.38,
              },
            ],
            color: -2.27,
          },
          {
            name: 'Healthcare Information Services',
            children: [
              {
                name: 'CERN',
                description: 'Cerner Corporation',
                size: 432,
                color: -3.98,
              },
            ],
            color: -3.67,
          },
          {
            name: 'Technical & System Software',
            children: [
              {
                name: 'ADSK',
                description: 'Autodesk, Inc.',
                size: 704,
                color: -3.47,
              },
            ],
            color: -1.06,
          },
          {
            name: 'Information & Delivery Services',
            children: [
              {
                name: 'DNB',
                description: 'The Dun & Bradstreet Corporation',
                size: 120,
                color: -3.77,
              },
              {
                name: 'NLSN',
                description: 'Nielsen Holdings plc',
                size: 255,
                color: 4.94,
              },
              {
                name: 'BR',
                description: 'Broadridge Financial Solutions, Inc.',
                size: 300,
                color: 4.71,
              },
            ],
            color: 0.14,
          },
          {
            name: 'Internet Software & Services',
            children: [
              {
                name: 'EQIX',
                description: 'Equinix, Inc. (REIT)',
                size: 850,
                color: 3.13,
              },
            ],
            color: -1.18,
          },
          {
            name: 'Diversified Computer Systems',
            children: [
              {
                name: 'HPQ',
                description: 'HP Inc.',
                size: 910,
                color: 3.86,
              },
            ],
            color: 1.65,
          },
          {
            name: 'Scientific & Technical Instruments',
            children: [
              {
                name: 'FLIR',
                description: 'FLIR Systems, Inc.',
                size: 210,
                color: -3.69,
              },
              {
                name: 'GRMN',
                description: 'Garmin Ltd.',
                size: 315,
                color: -1.79,
              },
              {
                name: 'FTV',
                description: 'Fortive Corporation',
                size: 700,
                color: -1.01,
              },
            ],
            color: -0.01,
          },
          {
            name: 'Data Storage Devices',
            children: [
              {
                name: 'STX',
                description: 'Seagate Technology plc',
                size: 273,
                color: -2.23,
              },
              {
                name: 'NTAP',
                description: 'NetApp, Inc.',
                size: 378,
                color: -2.74,
              },
              {
                name: 'WDC',
                description: 'Western Digital Corporation',
                size: 399,
                color: -0.35,
              },
            ],
            color: 1.59,
          },
          {
            name: 'Semiconductor- Memory Chips',
            children: [
              {
                name: 'MU',
                description: 'Micron Technology, Inc.',
                size: 1100,
                color: 4.82,
              },
            ],
            color: 4.72,
          },
          {
            name: 'Diversified Communication Services',
            children: [
              {
                name: 'SBAC',
                description: 'SBA Communications Corporation',
                size: 350,
                color: -3.57,
              },
              {
                name: 'CCI',
                description: 'Crown Castle International Corp. (REIT)',
                size: 900,
                color: -4.18,
              },
            ],
            color: -4.35,
          },
          {
            name: 'Semiconductor - Integrated Circuits',
            children: [
              {
                name: 'SWKS',
                description: 'Skyworks Solutions, Inc.',
                size: 350,
                color: -0.7,
              },
              {
                name: 'XLNX',
                description: 'Xilinx, Inc.',
                size: 350,
                color: -4.47,
              },
              {
                name: 'ADI',
                description: 'Analog Devices, Inc.',
                size: 700,
                color: -4.56,
              },
            ],
            color: -3.56,
          },
          {
            name: 'Diversified Electronics',
            children: [
              {
                name: 'GLW',
                description: 'Corning Incorporated',
                size: 560,
                color: 1.79,
              },
              {
                name: 'APH',
                description: 'Amphenol Corporation',
                size: 560,
                color: -1.96,
              },
              {
                name: 'TEL',
                description: 'TE Connectivity Ltd.',
                size: 644,
                color: -4.6,
              },
            ],
            color: -1.87,
          },
          {
            name: 'Multimedia & Graphics Software',
            children: [
              {
                name: 'TTWO',
                description: 'Take-Two Interactive Software, Inc.',
                size: 330,
                color: 0.95,
              },
              {
                name: 'EA',
                description: 'Electronic Arts Inc.',
                size: 1050,
                color: 3.37,
              },
              {
                name: 'ATVI',
                description: 'Activision Blizzard, Inc.',
                size: 1426,
                color: 0.24,
              },
            ],
            color: 2.28,
          },
          {
            name: 'Semiconductor Equipment & Materials',
            children: [
              {
                name: 'IPGP',
                description: 'IPG Photonics Corporation',
                size: 190,
                color: 4.26,
              },
              {
                name: 'SNPS',
                description: 'Synopsys, Inc.',
                size: 323,
                color: 2.25,
              },
              {
                name: 'KLAC',
                description: 'KLA-Tencor Corporation',
                size: 432,
                color: 1.44,
              },
              {
                name: 'LRCX',
                description: 'Lam Research Corporation',
                size: 665,
                color: 0.44,
              },
              {
                name: 'AMAT',
                description: 'Applied Materials, Inc.',
                size: 1196,
                color: -3.65,
              },
            ],
            color: -4.39,
          },
          {
            name: 'Semiconductor - Specialized',
            children: [
              {
                name: 'FSLR',
                description: 'First Solar, Inc.',
                size: 150,
                color: -2.42,
              },
              {
                name: 'NVDA',
                description: 'NVIDIA Corporation',
                size: 3700,
                color: 2.99,
              },
            ],
            color: -0.49,
          },
          {
            name: 'Information Technology Services',
            children: [
              {
                name: 'XRX',
                description: 'Xerox Corporation',
                size: 186,
                color: 0.21,
              },
              {
                name: 'FIS',
                description: 'Fidelity National Information Services, Inc.',
                size: 899,
                color: -4.82,
              },
              {
                name: 'CTSH',
                description: 'Cognizant Technology Solutions Corporation',
                size: 1260,
                color: 0.59,
              },
              {
                name: 'ACN',
                description: 'Accenture plc',
                size: 2814,
                color: 2.65,
              },
              {
                name: 'IBM',
                description: 'International Business Machines Corporation',
                size: 3388,
                color: 3.13,
              },
            ],
            color: -3.48,
          },
          {
            name: 'Communication Equipment',
            children: [
              {
                name: 'JNPR',
                description: 'Juniper Networks, Inc.',
                size: 266,
                color: -2.35,
              },
              {
                name: 'HRS',
                description: 'Harris Corporation',
                size: 494,
                color: 1.92,
              },
              {
                name: 'MSI',
                description: 'Motorola Solutions, Inc.',
                size: 504,
                color: 4.99,
              },
              {
                name: 'HPE',
                description: 'Hewlett Packard Enterprise Company',
                size: 616,
                color: -4.46,
              },
              {
                name: 'QCOM',
                description: 'QUALCOMM Incorporated',
                size: 2491,
                color: -1.39,
              },
              {
                name: 'CSCO',
                description: 'Cisco Systems, Inc.',
                size: 5208,
                color: -1.47,
              },
            ],
            color: -2.82,
          },
          {
            name: 'Telecom Services - Domestic',
            children: [
              {
                name: 'FTR',
                description: 'Frontier Communications Corporation',
                size: 9,
                color: 2.7,
              },
              {
                name: 'CTL',
                description: 'CenturyLink, Inc.',
                size: 531,
                color: 0.2,
              },
              {
                name: 'VZ',
                description: 'Verizon Communications Inc.',
                size: 5640,
                color: -3.49,
              },
              {
                name: 'T',
                description: 'AT&T Inc.',
                size: 6077,
                color: 3.74,
              },
            ],
            color: -4.69,
          },
          {
            name: 'Semiconductor - Broad Line',
            children: [
              {
                name: 'QRVO',
                description: 'Qorvo, Inc.',
                size: 225,
                color: -1.93,
              },
              {
                name: 'MCHP',
                description: 'Microchip Technology Incorporated',
                size: 585,
                color: -0.81,
              },
              {
                name: 'AVGO',
                description: 'Broadcom Inc.',
                size: 2538,
                color: 3.22,
              },
              {
                name: 'TXN',
                description: 'Texas Instruments Incorporated',
                size: 2914,
                color: 3.33,
              },
              {
                name: 'INTC',
                description: 'Intel Corporation',
                size: 6666,
                color: 1.07,
              },
            ],
            color: -3.37,
          },
          {
            name: 'Application Software',
            children: [
              {
                name: 'CDNS',
                description: 'Cadence Design Systems, Inc.',
                size: 345,
                color: -1.02,
              },
              {
                name: 'ANSS',
                description: 'ANSYS, Inc.',
                size: 391,
                color: -3.05,
              },
              {
                name: 'RHT',
                description: 'Red Hat, Inc.',
                size: 672,
                color: -4.61,
              },
              {
                name: 'INTU',
                description: 'Intuit Inc.',
                size: 1408,
                color: 3.81,
              },
              {
                name: 'CRM',
                description: 'salesforce.com, inc.',
                size: 2760,
                color: -1.61,
              },
              {
                name: 'ADBE',
                description: 'Adobe Systems Incorporated',
                size: 3312,
                color: 4.27,
              },
              {
                name: 'ORCL',
                description: 'Oracle Corporation',
                size: 5050,
                color: 2.13,
              },
            ],
            color: 0.98,
          },
          {
            name: 'Business Software & Services',
            children: [
              {
                name: 'IRM',
                description: 'Iron Mountain Incorporated',
                size: 338,
                color: -3.07,
              },
              {
                name: 'FFIV',
                description: 'F5 Networks, Inc.',
                size: 286,
                color: -2.67,
              },
              {
                name: 'CTXS',
                description: 'Citrix Systems, Inc.',
                size: 416,
                color: 3.47,
              },
              {
                name: 'CA',
                description: 'CA, Inc.',
                size: 494,
                color: -0.38,
              },
              {
                name: 'ADP',
                description: 'Automatic Data Processing, Inc.',
                size: 1612,
                color: 2.68,
              },
              {
                name: 'MSFT',
                description: 'Microsoft Corporation',
                size: 22748,
                color: 2.7,
              },
            ],
            color: -4.96,
          },
          {
            name: 'Internet Information Providers',
            children: [
              {
                name: 'TRIP',
                description: 'TripAdvisor, Inc.',
                size: 330,
                color: 2.56,
              },
              {
                name: 'AKAM',
                description: 'Akamai Technologies, Inc.',
                size: 352,
                color: -4.42,
              },
              {
                name: 'VRSN',
                description: 'VeriSign, Inc.',
                size: 528,
                color: 3.36,
              },
              {
                name: 'TWTR',
                description: 'Twitter, Inc.',
                size: 880,
                color: -1.59,
              },
              {
                name: 'FB',
                description: 'Facebook, Inc.',
                size: 17385,
                color: -1.61,
              },
              {
                name: 'GOOGL',
                description: 'Alphabet Inc.',
                size: 24395,
                color: -3.32,
              },
            ],
            color: 1.76,
          },
        ],
        color: -2.24,
      },
    ],
    color: 0.5,
  };
  export default data;